import request from "../../../../core/data/network/client/request";
import Api from "../../../../core/data/network/constants/api_routes";

export default {
  getClassifition: async () => {
    return request.get(Api.getClassifition());
  },
  getClassifitionBySearch: async (data) => {
    return request.get(Api.getClassifitionBySearching(data));
  },
  getReportClassifition: async (data) => {
    return request.get(Api.getReportClassition(data));
  },   
};
